import "../Myprojects.css"
import { MdPictureAsPdf } from "react-icons/md";
import React, { useState,useEffect,useRef } from "react";
import { jwtDecode } from "jwt-decode";
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import  { API_BASE_URL } from '../../../../configs/AppConfig';
import  { FILES_URL } from '../../../../configs/AppConfig';
import CustomDropdown from "../../../../components/DropdownClass";


const DetailsTr = ({data}) => {
      const [formInputs , setFormInputs] = useState({
            teamSize:"",
            class: "",
          });
      const [classes , setClasses] = useState([]);
      const classRef = useRef();
    
      const success = () => {
           message.success('Your assignment was successful');
          };
      const download = () => {
           message.success('Your PDF file downloaded successfully');
          };


        const { id } = useParams();
        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const role = decoded.role
        const teacherId = decoded.id;

        const isFormValid = formInputs.teamSize.trim() !== ''
          && formInputs.class !== ''    
          const assignProject = async()=>{
          await api.post(`${API_BASE_URL}assigned-projects`,{
          // points: formInputs.points.trim(),
          teamSize: formInputs.teamSize.trim(),
          class: formInputs.class,
          project : id

          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });
        }  

      const handleSubmit = (event) => {
    event.preventDefault();
    assignProject()
    success();
    setFormInputs({
          class:"",
          teamSize:"",
        })
    classRef.current.rest();   
    }
      const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="my-component"/>
  );
}
  const openPDF = () => {
    window.open(`${FILES_URL}${data.presentation?.url}`, "_blank"); // PDF must be in public folder
    download();
  };

useEffect(() => {
  if (role === "Teacher")
     api.get(`${API_BASE_URL}class/grade/${data.grade}`)
      .then((response) => {  
        setClasses(response.data);
        console.log("classes",response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [data.grade,role]);

// const claessData = ()=> { 
//   let oppmodels =[]
//   for (let i = 0; i < classes.length; i++) {
//  oppmodels.push(<option value={classes[i].id} >{classes[i].class}</option>)
//  }
//  return oppmodels
// }
const selectedClass = (classId) => {
  setFormInputs({...formInputs, class: classId});
}


  return (
    <div>
      {/* <Header /> */}
                <div className="pdf-preView" onClick={() => openPDF()}>
        <div className="pdf-pre">
          <MdPictureAsPdf className="pdf-img"/>
          <h3>Project Presentation</h3>
          {/* <MdOutlineCloudDownload className="pdf-img"/> */}
          </div>
          </div>

        <div className={role==="Admin" ? "overviewMain justify-center" : "overviewMain" }>
       <div className="proOverview detailsMrg flex flex-row">
        <div className="proOverviewChild">
              <h4 className="h4Create">Material needed : </h4>
              <MyComponent htmlContent={data.details?.materialNeeded}/>

            {role !== "Admin" ?  <h4 className="h4Create">Project objectives : </h4> : 
               <h4 className="h4Create">Project objectives for teacher : </h4> }
                <MyComponent htmlContent={data.details?.teacherObjectives}/>

              <h4 className="h4Create">Key vocabulary : </h4> 
              <MyComponent htmlContent={data.details?.keyVocabulary}/>

              {role !== "Admin" ? <h4 className="h4Create">Experiment steps : </h4>  : 
               <h4 className="h4Create">Experiment steps for teacher : </h4> }
              <MyComponent htmlContent={data.details?.teacherSteps}/>


                </div>
       <div className="proOverviewChild">
             {role !== "Admin" ? null : <div> <h4 className="h4Create">Project objectives for student : </h4>
              <MyComponent htmlContent={data.details?.studentObjectives}/>
              </div>}

             {role !== "Admin" ? null : <div>  <h4 className="h4Create">Experiment steps for student : </h4> 
              <MyComponent htmlContent={data.details?.studentSteps}/>
              </div>}
            <h4 className="h4Create">Assessment Options : </h4> 
              <MyComponent htmlContent={data.details?.assessmentOptions}/>

             <h4 className="h4Create">Hints & Tips : </h4> 
              <MyComponent htmlContent={data.details?.hintsTips}/>

              <h4 className="h4Create">Optional & Extras : </h4> 
              <MyComponent htmlContent={data.details?.optionalExtras}/>


                 </div>
      </div>
        <div className="overview-DevImgRight">
           {role !== "Admin" ?  <form className="right-OverviewTr" onSubmit={handleSubmit}>
           <h4>Assign to student</h4>
          {/* <div className="filterByBtn fliterMarOver">
            <MdOutlineSchool className="filterByicon"/>
            <span>Filter by class</span>
            <div className="dropdownImg"></div>
          </div> */}
    {/* <select
        className="class-select"
        name="class"
        value={formInputs.class}
        onChange={(e) =>setFormInputs({...formInputs, class: e.target.value})}
      >
        <option value="" disabled> Filter by class </option>
        {claessData()}
      </select> */}
      <div className="mb-[15px]">
      <CustomDropdown options={classes}
       selectedd={selectedClass}
       ref={classRef}
       type="Select Class"
       
       />
       </div>


           {/* <div className="createTeam createTeamMar">
            <span>Create Team</span>
            <div className="createSwip">
              <div></div>
            </div>
           </div> */}
           <div className="teamSize teamSizeMar">
            <span>Team Size</span>
            <input type="number" className="inputWidth" value={formInputs.teamSize} placeholder="Enter Team Size" 
            onChange={(e) =>setFormInputs({...formInputs, teamSize: e.target.value})}/>
           </div>
           <div className="AssignBtn">
            <button type="submit" disabled={!isFormValid}>Assign</button>
           </div>
           </form> : null}
        </div>
        </div>
    </div>
  );
};

export default DetailsTr;
